import React from 'react';
import { observer } from 'mobx-react';

import AppStorage from '../Storage/Storage';
import { translate } from '../utils/utils';
import Labels from '../enums/Labels';

import ErrorScreenContacts from './ErrorScreenContacts';

import './ErrorScreen.css';

class ErrorScreen extends React.PureComponent {
  private readonly storage: AppStorage;

  constructor(props: {}) {
    super(props);
    this.storage = AppStorage.getInstance();
  }

  render(): React.ReactElement {

    const productSpecificData = this.storage.getProductSpecificInfo;

    return (
      <div className="error-screen">
        <h1>
          {translate(Labels.ERROR_HEADER, this.storage.getLocale)}
        </h1>
        <p className="info-message">
          {translate(Labels.ERROR_P1, this.storage.getLocale, [productSpecificData.companyName])}
        </p>
        <ErrorScreenContacts />
      </div>
    );
  }
}

export default observer(ErrorScreen);
